import { useState } from "react";

export type ConfirmBlocker<TArgs extends any[] = []> = {
    state: "blocked" | "awaiting";
    onAction(...args: TArgs): void;
    reset(): void;
    proceed(): void;
};

export default function useDestructiveActionBlocker<TArgs extends any[] = []>(
    action: (...args: TArgs) => any,
    active = true,
): ConfirmBlocker<TArgs> {
    const [state, setState] = useState<ConfirmBlocker<TArgs>["state"]>("awaiting");
    const [pendingArgs, setPendingArgs] = useState<TArgs | null>(null);

    return {
        state,
        onAction: (...args: TArgs) => {
            if (active) {
                setPendingArgs(args);
                setState("blocked");
            } else {
                action(...args);
            }
        },
        reset: () => {
            setState("awaiting");
            setPendingArgs(null);
        },
        proceed: () => {
            setState("awaiting");
            if (pendingArgs) {
                action(...pendingArgs);
                setPendingArgs(null);
            }
        },
    };
}
